/* Organique r8 (28 Sep 2026) */
(function () {
  // Footer lists fold on phones (design change 14); on desktop they stay open.
  var mq = window.matchMedia('(max-width: 749px)');
  function syncFolds() {
    document.querySelectorAll('details[data-org-fold]').forEach(function (d) {
      var s = d.querySelector('summary');
      if (mq.matches) {
        if (!d.hasAttribute('data-org-touched')) d.open = false;
        if (s) s.removeAttribute('tabindex');
      } else {
        d.open = true;
        if (s) s.setAttribute('tabindex', '-1');
      }
    });
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('details[data-org-fold] > summary');
    if (!s) return;
    if (!mq.matches) { e.preventDefault(); return; }
    s.parentElement.setAttribute('data-org-touched', '');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncFolds); else syncFolds();
  if (mq.addEventListener) mq.addEventListener('change', syncFolds); else if (mq.addListener) mq.addListener(syncFolds);
})();
(function () {
  // (9) Phone menu: language switch, WhatsApp and account at the bottom (from the template in the footer)
  function fillDrawer() {
    var tpl = document.getElementById('OrgDrawerUtil');
    if (!tpl) return;
    var q = window.location.search;
    document.querySelectorAll('.menu-drawer__utility-links').forEach(function (box) {
      if (box.querySelector('.org-drawer-util')) return;
      box.appendChild(tpl.content.cloneNode(true));
      // keep preview/query parameters on the language links, as organique.js does for the header ones
      box.querySelectorAll('.org-drawer-util [data-org-setlang]').forEach(function (a) {
        var h = a.getAttribute('href');
        if (q && h && h.indexOf('?') === -1) a.setAttribute('href', h + q);
      });
    });
  }
  // (14) Payment icons under every Checkout button; the template exists only once online payment is active
  function payUnder() {
    var tpl = document.getElementById('OrgPayIcons');
    if (!tpl || !tpl.content.firstElementChild) return;
    document.querySelectorAll('.cart__checkout-button').forEach(function (b) {
      var next = b.nextElementSibling;
      if (next && next.classList.contains('org-pay-under')) return;
      b.insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
    });
  }
  function run() { fillDrawer(); payUnder(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; run(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
(function () {
  // (13) Computers only: load the welcome pop-up photo once the page has loaded, so it is there when the pop-up opens
  var img = document.querySelector('#OrgWelcome .org-modal__img');
  if (!img || !window.matchMedia || !window.matchMedia('(min-width: 750px)').matches) return;
  function warm() { img.loading = 'eager'; }
  if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm);
})();
(function () {
  // Third review: keep a number with its unit ("1000 ml", «200 مل»), "2 × 1000", a price with KD / د.ك
  // and a day with its month («29 سبتمبر») on one line. Runs on load and on anything added later (drawer, search).
  var NB = ' ';
  var RULES = [
    [/(\d)[  ]+(ml|g|kg|L|l|cm|مل|غ|كغ|كغم|لتر|سم|KD|د\.ك)(?![A-Za-z؀-ۿ0-9])/g, '$1' + NB + '$2'],
    [/(\d)[  ]*×[  ]*(\d)/g, '$1' + NB + '×' + NB + '$2'],
    [/(\d{1,2})[  ]+(January|February|March|April|May|June|July|August|September|October|November|December|يناير|فبراير|مارس|أبريل|إبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/g, '$1' + NB + '$2']
  ];
  var TEST = /\d[  ]*[^\s\d]|\d[  ]+[A-Za-z؀-ۿ×]/;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
  function fixText(node) {
    var t = node.nodeValue;
    if (!t || t.length < 3 || !/\d/.test(t) || !TEST.test(t)) return;
    var n = t;
    for (var i = 0; i < RULES.length; i++) n = n.replace(RULES[i][0], RULES[i][1]);
    if (n !== t) node.nodeValue = n;
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { if (root.parentNode && !SKIP[root.parentNode.nodeName]) fixText(root); return; }
    if (root.nodeType !== 1 || SKIP[root.nodeName]) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) { return n.parentNode && !SKIP[n.parentNode.nodeName] ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
    });
    var n;
    while ((n = w.nextNode())) fixText(n);
  }
  function start() {
    walk(document.body);
    var pending = [];
    var timer = null;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.type === 'characterData') pending.push(m.target);
        else for (var j = 0; j < m.addedNodes.length; j++) pending.push(m.addedNodes[j]);
      }
      if (timer) return;
      timer = setTimeout(function () {
        var batch = pending; pending = []; timer = null;
        for (var k = 0; k < batch.length; k++) if (batch[k].isConnected) walk(batch[k]);
      }, 60);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
